
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseFormSubmit from '@/components/BaseFormSubmit.vue'
import { ALERT_COLORS } from '@/store/base'
import LayoutsAuth from '@/layouts/Auth.vue'
import BaseAlert from '@/components/BaseAlert.vue'
import BaseFormSelect from '@/components/BaseFormSelect.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuth, BaseAlert, BaseFormSubmit, BaseFormSelect, LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const btnDisabled = ref(false)
    const initialValues = computed(() => {
      return {
        pref_id: store.state.user.user?.pref_id ?? 0,
      }
    })

    const schema = yup.object({
      pref_id: yup.number(),
    })

    const { handleSubmit, errors } = useForm({ validationSchema: schema, initialValues })

    const { value: pref_id } = useField<string>('pref_id')

    const onSubmit = handleSubmit(values => {
      btnDisabled.value = true
      axios
        .post('/account/change-pref-id', values)
        .then(response => {
          store.commit('user/setUser', response.data.payload)
          store.commit('base/setAlertMessages', { messages: [t('account.change_prefectures.success')], color: ALERT_COLORS.info })
        })
        .finally(() => btnDisabled.value = false)
    })

    onMounted(() => {
      store.dispatch('user/fetchPrefList')
    })

    return {
      t,
      errors,
      pref_id,
      onSubmit,
      btnDisabled,
      store
    }
  },
})
